export default __webpack_public_path__ + "static/media/Demonstracoes_Financeiras_da_GF_SA_2022_0591.87999730.pdf";